import { useCallback, useEffect, useState } from 'react';
import { rejoinRoom } from './components/BuildUpdate';
import { ConnectScreen } from './components/ConnectScreen';
import { RoomGame } from './components/RoomGame';
import { TitleBackdrop } from './components/splash/TitleScreen';
import { SIGNALLING_URL } from './config';
import { roomFromUrl, withRoom } from './lib/share';

// Read once at load (not in a state initialiser, which StrictMode runs twice):
// after an update reload, or from a shared link, straight into that lobby.
const LINKED_ROOM = rejoinRoom() ?? roomFromUrl(window.location.href);

export function App() {
  const [room, setRoom] = useState<string | null>(LINKED_ROOM);
  // The last lobby joined, to pre-fill the form after leaving it.
  const [lastRoom, setLastRoom] = useState(LINKED_ROOM ?? '');
  const [inMatch, setInMatch] = useState(false);
  const join = useCallback((next: string) => {
    setLastRoom(next);
    setRoom(next);
  }, []);
  const leave = useCallback(() => {
    setInMatch(false);
    setRoom(null);
  }, []);

  // The address bar names the lobby we're in: copyable, and a reload rejoins.
  useEffect(() => {
    window.history.replaceState(window.history.state, '', withRoom(window.location.href, room));
  }, [room]);

  return (
    <>
      {/* Stays mounted from the title screen through the lobby, so the shot never restarts. */}
      {!inMatch && <TitleBackdrop />}
      {room ? (
        <RoomGame
          signallingServerUrl={SIGNALLING_URL}
          roomId={room}
          onMatchChange={setInMatch}
          onLeave={leave}
        />
      ) : (
        <ConnectScreen defaultRoom={lastRoom} onConnect={join} />
      )}
    </>
  );
}
